var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_tracking_info"},[_c('div',{staticClass:"label-primary"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"data__tracking"},[_vm._v(" "+_vm._s(_vm.data)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }